<template>
  <BasicModal
    :title="'タスクの送付履歴'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container disp-scroll">
      <div class="input-box">
        <template v-if="getExistData(taskList)">
          <table class="table-box">
            <tr>
              <th class="table-th">宛先</th>
              <th class="table-th">タスクタイトル</th>
              <th class="table-th">既読 / 未読</th>
              <th class="table-th">送付日時</th>
            </tr>
            <template v-for="(task, idx) in taskList">
              <tr v-for="(log, idx2) in task.user_task_log" :key="idx">
                <td class="table-td">
                  <p>{{getUserName(log.send_user)}}</p>
                </td>
                <td class="table-td">
                  <p>{{task.title}}</p>
                </td>
                <td class="table-td">
                  <p>{{log.is_read ? '既読' : '未読'}}</p>
                </td>
                <td class="table-td">
                  <p>{{displayDateStr(log.sended_at)}}</p>
                </td>
              </tr>
            </template>
          </table>
        </template>
        <template v-else>
          送信履歴がありません
        </template>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">閉じる</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import displayDate from '@/functions/displayDate'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    taskList: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    getUserName (hash) {
      let name = '-'
      for (const user of this.users) {
        if (user.user_hash === hash) {
          name = user.username
        }
      }
      return name
    },
    getExistData (taskList) {
      let cnt = 0
      for (const t of taskList) {
        cnt += t.user_task_log.length
      }
      return cnt > 0 ? true : false
    },
    displayDateStr (time) {
      if (!time) return '-'
      return displayDate(time)
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 24px;
  height: 500px;
  overflow: auto;
}
.input-field {
  padding: 8px;
  text-align: left;
}
.table-box {
  display: table;
  max-height: calc(75vh - 180px);
  width: 100%;
  border-bottom: solid thin #ccc;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  p {
    text-align: center;
  }
}
.table-th {
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalTaskLog.vue